import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "product-features__wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "product-features__accordion-wrapper"
}
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = {
  key: 1,
  class: "product-features__accordion-wrapper"
}
const _hoisted_5 = { class: "product-features__accordion product-features__accordion--no-arrow" }
const _hoisted_6 = {
  key: 0,
  class: "product-features__accordion-headline",
  role: "heading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_product_features_list = _resolveComponent("product-features-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.productFeatures.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productFeatures, (productFeature, productFeatureIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `${productFeatureIndex}_productFeature`,
              class: _normalizeClass(["product-features__accordion", {
          'product-features__accordion--open': _ctx.isAccordionOpen(productFeatureIndex),
          'product-features__accordion--closed': !_ctx.isAccordionOpen(productFeatureIndex),
        }]),
              "aria-label": productFeature.headline
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(`product-features__accordion-headline product-features-list--id-${productFeatureIndex}`),
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleClass && _ctx.toggleClass(...args))),
                role: "heading"
              }, _toDisplayString(productFeature.headline), 3 /* TEXT, CLASS */),
              _cache[1] || (_cache[1] = _createTextVNode()),
              _createVNode(_component_product_features_list, {
                "scroll-less-element": `product-features-list--id-${productFeatureIndex}`,
                features: productFeature.features,
                "max-height": _ctx.featuresHeight,
                "show-more-link": false
              }, null, 8 /* PROPS */, ["scroll-less-element", "features", "max-height"])
            ], 10 /* CLASS, PROPS */, _hoisted_3))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : (_ctx.productFeatures.length === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.productStore.productDetails.isSet)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.productFeatures[0].headline), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _cache[2] || (_cache[2] = _createTextVNode()),
              _createVNode(_component_product_features_list, {
                "scroll-less-element": "product-details__headline--product-features",
                features: _ctx.productFeatures[0].features,
                "max-height": _ctx.featuresHeight,
                "show-more-link": true
              }, null, 8 /* PROPS */, ["features", "max-height"])
            ])
          ]))
        : _createCommentVNode("v-if", true)
  ]))
}